import {
  Button,
  Checkbox,
  DialogActions,
  DialogContent,
  FormControlLabel,
  Paper,
  Stack,
  Typography
} from '@mui/material';
import { TranslatedText } from '@ianesthesie-kit/core';
import React, { useState } from 'react';
import {
  DialogSecondaryAction,
  DialogTitleWithCloseAction,
  useDialogPromise
} from '@ianesthesie-kit/redux';
import { SurgicalEventService } from '@/modules/surgicalEvent/surgicalEvent.service';

export const SurgicalEventValidationWarningDialog = () => {
  const { closeAndResolve } = useDialogPromise();
  const [muteWarnings, setMuteWarnings] = useState(false);

  const onCancel = () => {
    closeAndResolve(false);
  };

  const onProceed = () => {
    if (muteWarnings) {
      SurgicalEventService.muteValidationWarning();
    }
    closeAndResolve(true);
  };

  return (
    <Paper sx={{ p: 0, maxWidth: 600, minWidth: { xs: 'unset', md: 600 } }}>
      <DialogTitleWithCloseAction onClose={onCancel}>
        <TranslatedText id="doctor-dashboard.undoableActionWarning.title" />
      </DialogTitleWithCloseAction>
      <DialogContent>
        <Stack gap={3}>
          <Typography paragraph variant="body1">
            <TranslatedText id="doctor-dashboard.details.seValidationDialog.body" />
          </Typography>
          <FormControlLabel
            control={
              <Checkbox
                checked={muteWarnings}
                onChange={(e, v) => setMuteWarnings(v)}
              />
            }
            label={
              <Typography variant="body2">
                <TranslatedText id="doctor-dashboard.undoableActionWarning.mute" />
              </Typography>
            }
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <DialogSecondaryAction onClick={onCancel}>
          <TranslatedText id="app.cancel" />
        </DialogSecondaryAction>
        <Button variant="contained" onClick={onProceed}>
          <TranslatedText id="doctor-dashboard.details.seValidationDialog.action" />
        </Button>
      </DialogActions>
    </Paper>
  );
};
